const mediaItems = [
  {
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20trailer%20still%20with%20dramatic%20action%20scene%2C%20explosion%20effects%2C%20intense%20lighting%2C%20film%20grain%20texture%2C%20dark%20atmospheric%20background%20with%20warm%20orange%20and%20red%20highlights%2C%20blockbuster%20movie%20aesthetic&width=800&height=450&seq=media-dsxy-01&orientation=landscape',
    tag: '预告片',
    title: '《封神第二部》终极预告',
    duration: '02:35',
    views: '128万',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20film%20making%20documentary%20style%2C%20director%20working%20on%20set%20with%20camera%20crew%2C%20warm%20cinematic%20lighting%2C%20professional%20film%20production%20atmosphere%2C%20dark%20background%20with%20subtle%20golden%20accents&width=800&height=450&seq=media-dsxy-02&orientation=landscape',
    tag: '幕后花絮',
    title: '《流浪地球3》拍摄幕后揭秘',
    duration: '08:12',
    views: '96万',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Film%20critic%20review%20video%20style%20with%20movie%20clips%20montage%2C%20professional%20analysis%20setting%2C%20cinematic%20lighting%20with%20warm%20tones%2C%20dark%20background%2C%20elegant%20editorial%20photography%20style&width=800&height=450&seq=media-dsxy-03&orientation=landscape',
    tag: '深度解读',
    title: '《奥本海默》视听语言深度解析',
    duration: '15:40',
    views: '73万',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-3">
            精彩预告
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-[480px] mx-auto">
            最新预告片、幕后花絮与深度解读，全方位了解影视作品
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <div
              key={item.title}
              className="group bg-background-50 rounded-2xl overflow-hidden cursor-pointer border border-background-200/60 transition-all duration-200 hover:border-background-300/60"
            >
              {/* Thumbnail */}
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors"></div>
                {/* Play button */}
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:bg-primary-500 group-hover:scale-110 transition-all duration-200 shadow-lg shadow-primary-500/30">
                    <i className="ri-play-fill text-white text-2xl ml-0.5"></i>
                  </div>
                </div>
                {/* Duration badge */}
                <div className="absolute bottom-3 right-3 bg-black/70 text-white text-[10px] font-medium px-2 py-1 rounded-md whitespace-nowrap">
                  {item.duration}
                </div>
              </div>

              {/* Info */}
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="inline-block bg-accent-100 text-accent-700 text-[10px] font-semibold px-2 py-0.5 rounded whitespace-nowrap">
                    {item.tag}
                  </span>
                  <span className="text-[11px] text-foreground-400 whitespace-nowrap">
                    <i className="ri-eye-line mr-1"></i>{item.views}
                  </span>
                </div>
                <h3 className="font-heading font-bold text-sm md:text-base text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                  {item.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}